const map = {
	"./Estigmas_espanol.png": 9416,
	"./LA_Pilatowsky_2023_espanol.png": 5054,
	"./LA_Pilatowsky_2023_ingles.png": 7308,
	"./abc_protocol.png": 1119,
	"./abc_protocol/abc_protocol_banner.png": 2522,
	"./abc_protocol/logos.png": 4182,
	"./abc_protocol/xenoo.png": 2237,
	"./aboutUs.png": 5285,
	"./backgroundDefault.jpeg": 3946,
	"./data.png": 6616,
	"./data.svg": 7470,
	"./knowledge.png": 2550,
	"./knowledge.svg": 6114,
	"./pnud_front.png": 3149,
	"./resources.png": 3185,
	"./resources.svg": 1065,
	"./resources2.png": 9399,
	"./surveys.png": 6643,
	"./surveys.svg": 7855
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1706;